'use client';

import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ReactNode } from 'react';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1100, // Updated to 1100px for mobile view
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    custom: {
      brown: '#B3907A',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    headerIconLabel: {
      color: '#a98c74',
      fontWeight: 400,
      fontSize: 14,
      textAlign: 'center',
      marginTop: 4,
      letterSpacing: 0.2,
    },
    navMenu: {
      color: '#B3907A',
      fontWeight: 500,
      fontSize: 16,
      letterSpacing: 0.5,
      textTransform: 'none',
      cursor: 'pointer',
      padding: '0 8px',
      transition: 'color 0.2s',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});

declare module '@mui/material/styles' {
  interface TypographyVariants {
    headerIconLabel: React.CSSProperties;
    navMenu: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    headerIconLabel?: React.CSSProperties;
    navMenu?: React.CSSProperties;
  }
  interface Palette {
    custom: {
      brown: string;
    };
  }
  interface PaletteOptions {
    custom?: {
      brown: string;
    };
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    headerIconLabel: true;
    navMenu: true;
  }
}

interface ThemeProviderProps {
  children: ReactNode;
}

export default function ThemeProvider({ children }: ThemeProviderProps) {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}
